import { selectorInitialState } from '../../common/redux/selector/reducerFor'
import { builtInLPOrigin, builtInOrigin, BuiltInState } from './model'
import { resourceSelectorInitialState, resourceSelectorReducer } from '../../common/resource/reducer'
import { environmentSelectorReducer } from '../../common/environment/reducer'
import { versionSelectorReducer } from '../../common/version/reducer'
import { ActionType, BuiltInAction, FetchedDetailedResourceAction } from './actions'
import { IframeLoadingState } from '@mulesoft/monitoring-center-components'

const landingPageInitialState = {
  environmentSelector: selectorInitialState,
  resourceSelector: resourceSelectorInitialState,
  versionSelector: selectorInitialState,
}

const initialState: BuiltInState = {
  landingPage: landingPageInitialState,
  environmentSelector: selectorInitialState,
  resourceSelector: resourceSelectorInitialState,
  versionSelector: selectorInitialState,
  isLoading: IframeLoadingState.LOADED,
  details: {
    isFetching: false,
    detailedResource: undefined,
    hidden: undefined
  },
  autoRefresh: {
    checked: undefined,
    frequency: undefined
  }
}

const environmentBuiltInReducer = environmentSelectorReducer(builtInOrigin)
const environmentLandingReducer = environmentSelectorReducer(builtInLPOrigin)
const resourceBuiltInReducer = resourceSelectorReducer(builtInOrigin)
const resourceLandingReducer = resourceSelectorReducer(builtInLPOrigin)
const versionBuiltInReducer = versionSelectorReducer(builtInOrigin)
const versionLandingReducer = versionSelectorReducer(builtInLPOrigin)

const reducer = (state: BuiltInState = initialState, action: BuiltInAction): BuiltInState => {
  state = {
    ...state,
    landingPage: {
      environmentSelector: environmentLandingReducer(state.landingPage.environmentSelector, action),
      resourceSelector: resourceLandingReducer(state.landingPage.resourceSelector, action),
      versionSelector: versionLandingReducer(state.landingPage.versionSelector, action),
    },
    environmentSelector: environmentBuiltInReducer(state.environmentSelector, action),
    resourceSelector: resourceBuiltInReducer(state.resourceSelector, action),
    versionSelector: versionBuiltInReducer(state.versionSelector, action),
  }

  switch (action.type) {
    case ActionType.IsLogPointsCompatible:
      return {...state, isLogPointsCompatible: action.payload.compatible}

    case ActionType.SetBuiltInStateFromLandingPage:
      return {
        ...state,
        environmentSelector: action.payload.environmentSelector,
        resourceSelector: action.payload.resourceSelector,
        versionSelector: action.payload.versionSelector
      }
      
    case ActionType.ChangeBuiltInState:
      return {...state, isLoading: action.payload.isLoading}

    case ActionType.ChangeBuiltInHiddenDetail:
      return {...state, details: {...state.details, hidden: action.payload.isDetailHidden}}

    case ActionType.FetchDetailedResource:
      return {...state, details: {...state.details, isFetching: true}}

    case ActionType.FetchedDetailedResource:
      return {
        ...state,
        details: {
          ...state.details,
          isFetching: false,
          detailedResource: (action as FetchedDetailedResourceAction).payload.detailedResource
        }
      }

    case ActionType.RangeChange:
      return {...state, range: action.payload.range}

    case ActionType.AutoRefreshChange:
      return {...state, autoRefresh: {checked: action.payload.checked, frequency: action.payload.frequency}}

    default:
      return state
  }
}

export default reducer
